import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAlertify from "vue-alertify";
var VuescrollTo = require("vue-scrollto");
import Aos from "aos";
import "aos/dist/aos.css";
import Firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import * as VueGoogleMaps from "vue2-google-maps";
const geofire = require('geofire');
import VueTippy, { TippyComponent } from "vue-tippy";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

//CONEXION AL PROYECTO DE PAGINA WEB
const firebaseConfigure = {
  apiKey: "AIzaSyC68q9u_i-noaNnXKwKkDqrl2HcHuFMaIg",
    authDomain: "paginawebar.firebaseapp.com",
    databaseURL: "https://paginawebar.firebaseio.com",
    projectId: "paginawebar",
    storageBucket: "paginawebar.appspot.com",
    messagingSenderId: "155958669344",
    appId: "1:155958669344:web:9bbaa0e62e350b86080c45",
    measurementId: "G-3J698V719T"
};
const app = Firebase.initializeApp(firebaseConfigure);
export const instanceWeb = app;
export const dbRealtimeSoliGrabaciones = app.database().ref("SolicitudesGrabaciones");
export const dbRealtimeSoliInformacion = app.database().ref("SolicitudesInformacion");
export const dbRealtimeSolicitudInformacionAR = app.database().ref("SolicitudesInformacionAR");
export const dbRealtimeUser = app.database().ref('Usuarios');
export const dbStorage = app.storage();

const firebaseConfigureEvaluaciones = {
    apiKey: "AIzaSyAp-CxpeJR8QLdnBKOOKmRMHGu99KLfwZg",
    authDomain: "sistema-ar-evaluaciones.firebaseapp.com",
    databaseURL: "https://sistema-ar-evaluaciones.firebaseio.com",
    projectId: "sistema-ar-evaluaciones",
    storageBucket: "sistema-ar-evaluaciones.appspot.com",
    messagingSenderId: "200005989252",
    appId: "1:200005989252:web:6df10c791ebc0f5b66e3d1"
}
const appEval = Firebase.initializeApp(firebaseConfigureEvaluaciones,"Secondary");
export const dbEval = appEval.firestore();

const firebaseConfigureAppMovil = {
    apiKey: "AIzaSyBtxohar0APihZUa7j9HHEvIFOTP4ZqC0k",
    authDomain: "appmovilar-1cb10.firebaseapp.com",
    databaseURL: "https://appmovilar-1cb10.firebaseio.com",
    projectId: "appmovilar-1cb10",
    storageBucket: "appmovilar-1cb10.appspot.com",
    messagingSenderId: "627872112052",
    appId: "1:627872112052:web:5e9048baa1addaf53ee6e1",
    measurementId: "G-JBMMDJGPSJ"
}
const appMovil = Firebase.initializeApp(firebaseConfigureAppMovil, "Third");
const dbAppMovil = appMovil.database();
export const dbRefName = dbAppMovil.ref("Users").child("Drivers");
const dbRef = dbAppMovil.ref('active_drivers');
export const geofireRef = new geofire.GeoFire(dbRef);
export const dbRefAppMovil = appMovil;
export const dbAssa = dbAppMovil.ref("Assa").child("AsistenciasEnCurso");
export const dbCoordenadas = dbAppMovil.ref("Coordenadas");

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyBtxohar0APihZUa7j9HHEvIFOTP4ZqC0k",
      libraries: "places",
    },
  });
Vue.use(VueAlertify);
Vue.use(VuescrollTo, { offset: -60 });
Vue.use(VueSweetalert2);
Vue.use(VueFileAgent);
Vue.use(Toast);

Aos.init({
    duration: 2000,
    easing: "linear",
    offset: 120,
    once: true,
    anchorPlacement: "top-bottom"
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
